// extracted by mini-css-extract-plugin
export default {"login-form":"LoginPage_login-form__rQkut"};